/**
 * Whether a recipient read says this caller has NO phone — the predicate behind `useNeedsPhoneConnect`.
 * Import-free so it is unit-tested without the app's graph.
 *
 * `undefined` (the read is in flight) and `null` (the search index still lags a fresh signup) are both
 * UNKNOWN, not "no phone": the answer is yes only once a recipient has been read AND carries none.
 */
export function recipientNeedsPhone(recipient: { phone?: string | null } | null | undefined): boolean {
  return !!recipient && !recipient.phone;
}
